// React Feather icons
// https://github.com/carmelopullara/react-feather
// Note: Icons should be named for their purpose, rather than the actual icon.
//       The goal being to reduce multiple uses of the same icon for different purposes.

// Logo
export const ODYSEE_LOGO = 'OdyseeLogo';
export const ODYSEE_WHITE_TEXT = 'OdyseeLogoWhiteText';
export const ODYSEE_DARK_TEXT = 'OdyseeLogoDarkText';
export const AR = 'Ar';

// User
export const SIGN_OUT = 'SignOut';
export const SIGN_IN = 'SignIn';
export const SIGN_UP = 'Key';
export const ANONYMOUS = 'Anonymous';

// File types
export const IMAGE = 'Image';
export const AUDIO = 'HeadPhones';
export const VIDEO = 'Video';
export const TEXT = 'FileText';
export const POST = 'Post';
export const REPOST = 'Repeat';

// Categories
export const HOME = 'Home';
export const MUSIC = 'MusicCategory';
export const MOVIES = 'Movies';
export const WILD_WEST = 'WildWest';
export const UNIVERSE = 'Universe';
export const CHEESE = 'Cheese';
export const PEACE = 'Peace';
export const PORK_BUN = 'PorkBun';
export const MIND_BLOWN = 'MindBlown';
export const CONSPIRACY = 'Conspiracy';
export const RABBIT_HOLE = 'RabbitHole';
export const TECH = 'Speaker';
export const NEWS = 'Aperature';
export const ENLIGHTENMENT = 'Anchor';
export const GAMING = 'Gaming';
export const SCIENCE = 'Science';
export const SPORTS = 'Sports';
export const LIFE = 'Life';
export const ARTISTS = 'Artists';
export const MYSTERIES = 'Mysteries';
export const TECHNOLOGY = 'Technology';
export const EDUCATION = 'Education';
export const POP_CULTURE = 'Pop Culture';
export const CHEF = 'Chef';
export const STAR = 'star';
export const DISCOVER = 'Compass';
export const HOLIDAY = 'Holiday';
export const COMEDY = 'Comedy';
export const LIFESTYLE = 'Lifestyle';
export const GHOST = 'Ghost';
export const SPIRITUALITY = 'Spirituality';
export const HORROR = 'Horror';

// Badges
export const BADGE_MOD = 'BadgeMod';
export const BADGE_ADMIN = 'BadgeAdmin';
export const BADGE_STREAMER = 'BadgeStreamer';
export const BADGE_SPROUT = 'BadgeSprout';

// Player
export const PLAY = 'Play';
export const PLAY_PREVIOUS = 'Play Previous';
export const REPLAY = 'Replay';
export const REPEAT = 'Repeat';
export const SHUFFLE = 'Shuffle';
export const VOLUME_MUTED = 'VolumeX';

// Livestreams
export const LIVESTREAM = 'Livestream';
export const LIVESTREAM_SOLID = 'LivestreamSolid';
export const LIVESTREAM_MONOCHROME = 'LivestreamMono';
export const LIVESTREAM_MEMBERSHIP = 'LivestreamMembership';

// Playlists
export const PLAYLIST = 'Playlist';
export const PLAYLIST_ADD = 'PlaylistAdd';
export const PLAYLIST_FILLED = 'PlaylistFilled';
export const PLAYLIST_PLAYBACK = 'PlaylistPlayback';
export const WATCH_HISTORY = 'WatchHistory';

// Share
export const WHATSAPP = 'WhatsApp';
export const FACEBOOK = 'Facebook';
export const TWITTER = 'Twitter';
export const TELEGRAM = 'Telegram';
export const REDDIT = 'Reddit';
export const EMBED = 'Embed';
export const SHARE_LINK = 'ShareLink';

// Other
export const ARRANGE = 'Arrange';
export const CREDITCARD = 'Credit Card';
export const SWAP = 'Swap';
export const EXCHANGE = 'Exchange';
export const MEMBERSHIP = 'Membership';
export const GOLIVE = 'GOLIVE';
export const VIEW_TILES = 'TileView';
export const VIEW_LIST = 'ListView';
export const EMOJI = 'Emoji';
export const STICKER = 'Sticker';
export const FEATURED = 'Featured';
export const EARLY_ACCESS = 'EarlyAccess';
export const MEMBER_BADGE = 'MemberBadge';
export const NO_ADS = 'NoAds';
export const PREMIUM = 'Premium';
export const PREMIUM_PLUS = 'PremiumPlus';
export const UPGRADE = 'Upgrade';
export const DISMISS_ALL = 'DismissAll';
export const SUBMIT = 'Submit';
export const FILTERED_BY_LANG = 'FilteredByLang';
export const FINANCE = 'DollarSign';
export const USD = 'USD';
export const EURO = 'EUR';
export const REWARDS = 'Award';
export const ALERT = 'AlertCircle';
export const INFO = 'InfoCircle';
export const WARNING = 'Warning';
export const COPY = 'Clipboard';
export const ARROW_LEFT = 'ChevronLeft';
export const ARROW_RIGHT = 'ChevronRight';
export const DOWNLOAD = 'Download';
export const PUBLISH = 'UploadCloud';
export const FETCH = 'Fetch';
export const REMOVE = 'X';
export const ADD = 'Plus';
export const SUBTRACT = 'Subtract';
export const EDIT = 'Edit';
export const DELETE = 'Trash';
export const REPORT = 'Flag';
export const HELP = 'HelpCircle';
export const CHAT = 'MessageCircle';
export const COMPACT = 'CompactMode';
export const EXPAND = 'ExpandedMode';
export const FEEDBACK = 'MessageSquare';
export const SEARCH = 'Search';
export const SPACEMAN = 'Spaceman';
export const CHANNEL = 'AtSign';
export const REFRESH = 'RefreshCw';
export const MORE = 'More';
export const COPY_LINK = 'CopyLink';
export const ACCOUNT = 'User';
export const SETTINGS = 'Settings';
export const FILTER = 'Filter';
export const INVITE = 'Users';
export const FILE = 'File';
export const OPTIONS = 'Sliders';
export const UP = 'ChevronUp';
export const UP_TOP = 'ChevronUpTop';
export const DOWN = 'ChevronDown';
export const DOWN_BOTTOM = 'ChevronDownBottom';
export const DRAG = 'DragAndDrop';
export const SECURE = 'Lock';
export const MENU = 'Menu';
export const TRANSACTIONS = 'FileText';
export const LBRY = 'Lbry';
export const USDC = 'USDC';
export const BNB = 'BNB';
export const BASE = 'Base';
export const ETH = 'ETH';
export const LBC = 'LBC';
export const WANDER = 'Wander';
export const TIMERCHECK = 'Clock';
export const LIGHT = 'Sun';
export const DARK = 'Moon';
export const LIBRARY = 'Folder';
export const TAG = 'Tag';
export const SUPPORT = 'TrendingUp';
export const BLOCK = 'Slash';
export const MUTE = 'VolumeX';
export const UNBLOCK = 'Circle';
export const VIEW = 'View';
export const EYE = 'Eye';
export const EYE_OFF = 'EyeOff';
export const BACK = 'Back';
export const TRENDING = 'Trending';
export const TOP = 'Top';
export const NEW = 'New';
export const MORE_VERTICAL = 'MoreVertical';
export const DOWNLOADABLE = 'Downloadable';
export const VALIDATED = 'Check';
export const SLIDERS = 'Sliders';
export const ANALYTICS = 'BarChart2';
export const PURCHASED = 'Key';
export const BUY = 'Buy';
export const SEND = 'Send';
export const RECEIVE = 'Receive';
export const CAMERA = 'Camera';
export const NOTIFICATION = 'Bell';
export const REPLY = 'Reply';
export const YOUTUBE = 'Youtube';
export const UPVOTE = 'Upvote';
export const DOWNVOTE = 'Downvote';
export const CONTROVERSIAL = 'Controversial';

export const COMMUNITY = 'Community';
export const FIRE_ACTIVE = 'FireActive';
export const SLIME_ACTIVE = 'SlimeActive';
export const FIRE = 'Fire';
export const SLIME = 'Slime';
export const PIN = 'Pin';
export const BEST = 'Best';
export const CREATOR_LIKE = 'CreatorLike';
export const STACK = 'stack';
export const TIME = 'time';
export const GLOBE = 'globe';
export const RSS = 'rss';
export const APPEARANCE = 'Appearance';
export const CONTENT = 'Content';
export const OVERVIEW = 'Activity';
export const WALLET = 'List';
export const COIN_SWAP = 'CoinSwap';
export const PHONE = 'Phone';
export const COMPLETE = 'Check';
export const COMPLETED = 'CheckCircle';
export const NOT_COMPLETED = 'Circle';
export const SUBSCRIBE = 'Heart';
export const SUBSCRIBED = 'HeartSolid';
export const UNSUBSCRIBE = 'BrokenHeart';
export const BELL = 'Bell';
export const BELL_ON = 'BellOn';
export const UNLOCK = 'Unlock';
export const LOCK = 'Lock';
export const WEB = 'Globe';
export const SHARE = 'Share2';
export const EXTERNAL = 'ExternalLink';
